import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { userApi } from '../api/userApi'
import toast from "react-hot-toast"
import { baseQueryWithCsrf } from "./baseQueryWithCsrf";

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: baseQueryWithCsrf,
    endpoints: (builder) => ({
        register: builder.mutation({
            query(body) {
                return {
                    url: "/register",
                    method: "POST",
                    body,
                }
            },
            async onQueryStarted(args, {dispatch, queryFulfilled,}){
                try {
                 await queryFulfilled
                 await dispatch(userApi.endpoints.getMe.initiate(null))
                 toast.success("Verification email sent to your Gmail", {
                    duration: 20000, // Duration in milliseconds (2 minutes)
                  });
        } catch (error) {
                    console.log(error);
                }
            },
        }),

        login: builder.mutation({
            query(body) {
                return {
                    url: "/login",
                    method: "POST",
                    body,
                }
            },
            async onQueryStarted(args, {dispatch, queryFulfilled,}){
                try {
                 await queryFulfilled
                 await dispatch(userApi.endpoints.getMe.initiate(null))
                 toast.success("Successfully Logged In")
                } catch (error) {
                    console.log(error);
                }
            }
        }),

        verifyToken: builder.mutation({
            query: (body) => ({
                url: `/verify-email`,
                method: "POST",
                body,
            }),
        }),

        
        phoneVerifyToken: builder.mutation({
            query: (body) => ({
                url: `/verify-phone`,
                method: "POST",
                body,
            }),
        }),


        resendEmailVerification: builder.mutation({
    query: (body) => ({
        url: `/resend-email-verification`,
        method: "POST",
        body,
    }),
}),

        resendPhoneVerification: builder.mutation({
    query: (body) => ({
        url: `/resend-phone-verification`,
        method: "POST",
        body,
    }),
}),


        logout: builder.query({
            query: () => "/logout",
        }),
    }),
});

export const {useResendPhoneVerificationMutation, useResendEmailVerificationMutation, usePhoneVerifyTokenMutation, useLoginMutation, useRegisterMutation, useLazyLogoutQuery, useVerifyTokenMutation} = authApi;